import { useState } from 'react';

export default function Contact() {
  const contactInfo = [
    {
      icon: 'ri-phone-line',
      title: 'Phone',
      details: '+44(0) 7774 218 135',
      action: 'tel:07774218135'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      details: 'Mail@VineCE.co.uk',
      action: 'mailto:Mail@VineCE.co.uk'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Office',
      details: 'Alton, Hampshire GU34 2UW',
      action: null
    },
    {
      icon: 'ri-time-line',
      title: 'Business Hours',
      details: 'Mon - Fri: 9:00 AM - 5:00 PM',
      action: null
    }
  ];

  return (
    <section id="contact" className="py-20 bg-stone-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-3">Contact Us</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ready to start your next engineering project? Contact us today to discuss how we could be of assistance or to request a quotation.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Contact Information */}
          <div>
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Contact Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              {contactInfo.map((info, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className={`${info.icon} text-emerald-600 text-xl`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800 mb-1">{info.title}</h4>
                    {info.action ? (
                      <a 
                        href={info.action}
                        className="text-gray-600 hover:text-emerald-600 transition-colors cursor-pointer"
                      >
                        {info.details}
                      </a>
                    ) : (
                      <p className="text-gray-600 whitespace-pre-line">{info.details}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Map */}
            <div>
              <h4 className="font-semibold text-gray-800 mb-3">Our Location</h4>
              <div className="bg-white rounded-lg overflow-hidden border border-stone-200">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2494.123456789!2d-0.9736!3d51.1537!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48742c7b9b9b9b9b%3A0x9b9b9b9b9b9b9b9b!2sAlton%2C%20Hampshire%20GU34%202!5e0!3m2!1sen!2suk!4v1234567890"
                  width="100%"
                  height="350"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Vine Consulting Engineers Location - Alton, Hampshire"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}